export function getDictonary(locale) {
  return require(`react-intl/locale-data/${getDictonaryName(locale)}`)
}

export function getDictonaryName(locale) {
  if (!locale) {
    return 'en'
  }

  let dictonaryToLoad = locale

  if (locale.includes('_')) {
    dictonaryToLoad = locale.split('_')[0]
  }

  if (locale.includes('-')) {
    dictonaryToLoad = locale.split('-')[0]
  }

  return dictonaryToLoad
}

export function toDash(locale) {
  if (!locale) {
    return
  }

  let dictonaryToLoad = locale

  if (locale.includes('_')) {
    dictonaryToLoad = locale.replace('_', '-')
  }

  return dictonaryToLoad
}

export function serializeLocale(locale) {
  return {
    id: locale.id,
    name: locale.name,
    parent: locale.parent,
    isTranslationLocale: locale.isTranslationLocale,
    code: toDash(locale.code) || 'en-gb',
  }
}

export function getLocaleOnServer(req) {
  if (req.query.locale) {
    return { code: req.query.locale }
  }

  const cookieLocale = req.cookies.locale

  try {
    return cookieLocale ? JSON.parse(cookieLocale) : null
  } catch {
    // NOTE: fallback, for some accounts we get a different response
    return cookieLocale ? { code: cookieLocale } : null
  }
}

export function onIntlError(error) {
  console.log(error)
}
